import { render, staticRenderFns } from "./MonthlyTabs.vue?vue&type=template&id=045ca501"
import script from "./MonthlyTabs.vue?vue&type=script&lang=js"
export * from "./MonthlyTabs.vue?vue&type=script&lang=js"
import style0 from "./MonthlyTabs.vue?vue&type=style&index=0&id=045ca501&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports